import { useEffect, useState } from 'react';

const ONE_SECOND = 1_000;
const decrement = (n: number): number => n - 1;
/**
 * Counts down from `initialSeconds` to zero, updating the return value once every second.
 *
 * @param initialSeconds - number of seconds to start the countdown
 * @param onTimeout - optional callback called after timeout
 * @returns {number} - seconds remaining
 */
export const useTimer = (initialSeconds: number, onTimeout?: () => void): number => {
    const [seconds, setSeconds] = useState(initialSeconds);

    useEffect(() => {
        if (seconds <= 0) {
            onTimeout?.();
            return undefined;
        }

        const timeout = setTimeout(setSeconds, ONE_SECOND, decrement);

        return () => clearTimeout(timeout);
    }, [seconds, onTimeout]);

    return seconds;
};
